import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Field } from '../../../_models/field';
import { Router } from '@angular/router';
import { UserProfile } from '../../../_models/user-profile';
import { PortalApiService } from '../../../_services/portal-api.service';
import { FieldFilters } from '../../../_models/preferences';

@Component({
  selector: 'app-preview-field',
  templateUrl: './preview-field.component.html',
  styleUrls: ['./preview-field.component.css']
})
export class PreviewFieldComponent implements OnInit {
  @Input() fieldArray: Field[] = [];
  @Input() isUserFields: boolean;
  @Input() isAllFields: boolean;
  @Input() listDisplay: boolean;
  @Input() userProfile: UserProfile;
  @Input() filters: FieldFilters;
  @Output() updateUserFields: EventEmitter<Field> = new EventEmitter();
  sortColumn: string = null;
  sortDesc: boolean = false;
  isBulkEdit: boolean = false;

  paginatePerPage: number = 24;
  p1: number = 1;
  fieldArraySort = {
    isFavorite: true,
    fieldName: true,
  };

  constructor(
    private router: Router,
    private apiService: PortalApiService
  ) {}

  ngOnInit(): void {
    this.isBulkEdit = this.router.url.includes('bulkedit');
  }

  goToFieldPage(fieldID: number) {
    this.router.navigate(['/app/Portal/field/' + fieldID]);
  }

  addFieldToFavorites(field: Field, index: number) {
    this.apiService.addFieldToFavorites(field.fieldID)
      .subscribe(() => {
        this.updateUserFields.emit(field);
      });
  }

  removeFieldFromFavorites(field: Field, index: number) {
    this.apiService.removeFieldFromFavorites(field.fieldID)
      .subscribe(() => {
        this.updateUserFields.emit(field);
      });
  }

  sortFieldsBy(column: string | any) {
    this.fieldArraySort[column] = !this.fieldArraySort[column];
    this.sortColumn = column;
    this.sortDesc = this.fieldArraySort[column];
  }

  navigateToBulk(fieldID: number) {
    this.router.navigate([`app/Portal/bulkedit/field/${fieldID}/run-tickets`], {
      queryParams: { view: 'bulk' }
    });
  }
}
